import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useLandscapeHistory } from '../hooks/useLandscapes';
const ACTION_LABELS = {
    rule_add: 'Added by rule',
    rule_resuggest: 'Re-suggested by rule',
    rule_suppressed: 'Rule suggestion suppressed',
    manual_add: 'Added manually',
    manual_remove: 'Removed manually'
};
export function formatTimestamp(ts) {
    return ts ? new Date(Number(ts.seconds) * 1000).toLocaleString() : '';
}
/** Append-only trail of why each opportunity is, or is not, in the Landscape. */ export function LandscapeHistory({ landscapeId }) {
    const { data: events = [], isLoading, error } = useLandscapeHistory(landscapeId);
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-2",
        "data-testid": Testids.landscapes.historyPanel,
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "text-base font-semibold",
                children: "History"
            }),
            isLoading && /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-muted-foreground",
                children: "Loading…"
            }),
            error && /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-muted-foreground",
                children: "Could not load history."
            }),
            !isLoading && !error && events.length === 0 && /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-muted-foreground",
                children: "No membership changes yet."
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "space-y-1",
                children: events.map((e)=>/*#__PURE__*/ _jsxs("li", {
                        className: "flex flex-wrap items-center gap-2 text-sm",
                        "data-testid": Testids.landscapes.historyEvent,
                        "data-action": e.action,
                        "data-opportunity-id": e.opportunityId,
                        children: [
                            /*#__PURE__*/ _jsx(SpecraBadge, {
                                variant: "outline",
                                children: ACTION_LABELS[e.action] ?? e.action
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-muted-foreground",
                                children: e.opportunityId
                            }),
                            e.reason && /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    "“",
                                    e.reason,
                                    "”"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                className: "text-xs text-muted-foreground",
                                children: [
                                    e.actor && `${e.actor} · `,
                                    formatTimestamp(e.createdAt)
                                ]
                            })
                        ]
                    }, e.id))
            })
        ]
    });
}
